import ImagePicker from "./ImagePicker";

function Field({ label, children }) {
  return (
    <div>
      {label && <label className="label-x">{label}</label>}
      {children}
    </div>
  );
}

export default function FieldRenderer({ type, value, onChange, label, testid, error }) {
  switch (type) {
    case "textarea":
      return (
        <Field label={label}>
          <textarea
            rows={4}
            className={`input-x ${error ? "border-red-400" : ""}`}
            value={value ?? ""}
            onChange={(e) => onChange(e.target.value)}
            data-testid={testid}
            aria-invalid={!!error}
          />
          {error && <div className="text-xs text-red-600 mt-1" data-testid={`${testid}-error`}>{error}</div>}
        </Field>
      );
    case "image":
      return (
        <Field label={label}>
          <ImagePicker value={value} onChange={onChange} aspect="4/3" />
          {error && <div className="text-xs text-red-600 mt-1" data-testid={`${testid}-error`}>{error}</div>}
        </Field>
      );
    case "icon":
      return (
        <Field label={label}>
          <input
            className={`input-x font-mono-tab ${error ? "border-red-400" : ""}`}
            value={value ?? ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder="ShieldCheck, Globe2, …"
            data-testid={testid}
            aria-invalid={!!error}
          />
          {error && <div className="text-xs text-red-600 mt-1" data-testid={`${testid}-error`}>{error}</div>}
          <div className="text-[10px] text-[#6B6B6B] mt-1.5">
            Use any{" "}
            <a
              href="https://lucide.dev/icons/"
              target="_blank"
              rel="noreferrer"
              className="text-[#B8860B] underline"
            >
              lucide.dev icon name
            </a>{" "}
            (PascalCase).
          </div>
        </Field>
      );
    case "stringlist":
      return (
        <Field label={label}>
          <textarea
            rows={4}
            className={`input-x ${error ? "border-red-400" : ""}`}
            placeholder="One item per line"
            value={Array.isArray(value) ? value.join("\n") : ""}
            onChange={(e) => onChange(e.target.value.split("\n").filter((s) => s !== ""))}
            data-testid={testid}
            aria-invalid={!!error}
          />
          {error && <div className="text-xs text-red-600 mt-1" data-testid={`${testid}-error`}>{error}</div>}
        </Field>
      );
    case "text":
    default:
      return (
        <Field label={label}>
          <input
            className={`input-x ${error ? "border-red-400" : ""}`}
            value={value ?? ""}
            onChange={(e) => onChange(e.target.value)}
            data-testid={testid}
            aria-invalid={!!error}
          />
          {error && <div className="text-xs text-red-600 mt-1" data-testid={`${testid}-error`}>{error}</div>}
        </Field>
      );
  }
}
